import { put, take, takeEvery, select } from 'redux-saga/effects';
import ktRequest from '../utils/request';
import moment from 'moment';

import _ from 'lodash';

export function * createSchedule (payload) {
  const { centerId, roomId, startDate, endDate, employees, breakMinutes } = payload.schedulePayload;

  const newShiftsJson = yield ktRequest.post('create-schedule', {
    centerId,
    roomId,
    startDate,
    endDate,
    employees,
    breakMinutes
  }, 'timecards');

  const newShifts = yield newShiftsJson.json();

  for (const newShift of newShifts) {
    yield put({
      type: 'ADD_SCHEDULE',
      schedule: {
        id: parseInt(newShift.id, 10),
        roomId: parseInt(roomId, 10),
        start: startDate.toISOString(),
        end: endDate.toISOString(),
        employeeId: parseInt(newShift.employeeId, 10),
        breakMinutes: newShift.breakMinutes
      }
    });
  }

  yield put({
    type: 'CREATE_SCHEDULE_SUCCESS'
  });
}

export function * editSchedule (payload) {
  const { centerId, shiftId, roomId, startDate, endDate, employees, breakMinutes } = payload.schedulePayload;

  yield put({
    type: 'EDIT_SCHEDULE'
  });

  yield ktRequest.post('update-schedule', {
    centerId,
    shiftId,
    roomId,
    startDate,
    endDate,
    employees,
    breakMinutes
  }, 'timecards');

  yield put({
    type: 'EDIT_SCHEDULE_SUCCESS'
  });
}

export function * deleteSchedule (payload) {
  const { centerId, shiftId } = payload.schedulePayload;

  yield put({
    type: 'DELETE_SCHEDULE'
  });

  yield ktRequest.post('delete-schedule', {
    centerId,
    shiftId
  }, 'timecards');

  yield put({
    type: 'DELETE_SCHEDULE_SUCCESS'
  });
}

export function * copySchedule (payload) {
  const { centerId, roomId, employeeId, fromStartDate, fromEndDate, toStartDate } = payload.schedulePayload;

  const newShiftsJson = yield ktRequest.post('copy-schedule', {
    centerId,
    roomId,
    employeeId,
    fromStartDate: fromStartDate.toISOString(),
    fromEndDate: fromEndDate.toISOString(),
    toStartDate
  }, 'timecards');

  const newShifts = yield newShiftsJson.json();

  for (const newShift of newShifts) {
    yield put({
      type: 'ADD_SCHEDULE',
      schedule: {
        id: parseInt(newShift.id, 10),
        roomId: parseInt(newShift.roomId, 10),
        start: moment(newShift.start).toISOString(),
        end: moment(newShift.end).toISOString(),
        employeeId: parseInt(newShift.employeeId, 10),
        breakMinutes: newShift.breakMinutes
      }
    });
  }

  yield put({
    type: 'HIDE_COPY_MODAL'
  });
}

export function * fetchSchedules (payload) {
  const state = yield select();
  if (!state.identity.centerId) {
    yield take('FETCH_PROFILE_SUCCESS');
  }

  yield put({
    type: 'FETCH_SCHEDULES_LOADING'
  });

  const newState = yield select();

  const schedulesResult = yield ktRequest.get('schedules?centerId=' + newState.identity.centerId, 'timecards');
  const { schedules } = schedulesResult;

  // group schedules by employee id
  let groupedByEmployeeId = _.groupBy(schedules, 'employeeId');
  Object.keys(groupedByEmployeeId).forEach(key => {
    let obj = {};
    const value = groupedByEmployeeId[key];

    value.forEach(schedule => {
      const { start } = schedule;
      const formattedStart = moment(start).format('YYYY-MM-DD');

      if (obj[formattedStart] === undefined) {
        obj[formattedStart] = [schedule];
      } else {
        obj[formattedStart].push(schedule);
      }
    });

    groupedByEmployeeId[key] = obj;
  });

  console.log(groupedByEmployeeId);

  yield put({
    type: 'FETCH_SCHEDULES_SUCCESS',
    schedules: schedulesResult.schedules
  });
}

export const schedulingSagas = [
  takeEvery('CREATE_SCHEDULE_REQUEST', createSchedule),
  takeEvery('EDIT_SCHEDULE_REQUEST', editSchedule),
  takeEvery('COPY_SCHEDULE_REQUEST', copySchedule),
  takeEvery('DELETE_SCHEDULE_REQUEST', deleteSchedule),
  takeEvery('FETCH_SCHEDULES', fetchSchedules)
];
